<template>
  <div>
    <b-modal id="addrefund-modal" style="justify-content: space-around" hide-footer title="افزودن اعتبار"
      @hide="hideAddRefundModal">
      <b-alert :show="error.length > 0" variant="danger">
        <p v-for="er in error" v-bind:key="er">{{ er }}</p>
      </b-alert>
      <b-form>
        <b-row>
          <b-col>
            <b-form-group label="مبلغ (ریال):" label-for="input_price">
              <b-input-group>
                <!-- <b-input
                  class="text-right ltr"
                  id="input_price"
                  v-model="price"
                  required
                ></b-input> -->
                <number-seprator class="text-right" v-model="price"></number-seprator>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mt-3">
          <b-col>
            <b-button style="width: 100%" variant="danger" @click="hideAddRefundModal">بازگشت</b-button>
          </b-col>
          <b-col>
            <b-button style="width: 100%" variant="primary" id="btnSave"
              :class="loading ? 'spinner spinner-light spinner-right' : ''" @click="sendRequest">پرداخت</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
  </div>
</template>
<style scoped>
.ltr {
  direction: ltr;
}

.spinner.spinner-right {
  padding-left: 3.5rem !important;
}
</style>
<script>
import MDDropdown from "../../components/MDDropdown";
import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";
import numberSeprator from "../../components/numberSeprator.vue";

export default {
  name: "addRefund",
  components: { MDDropdown, numberSeprator },
  data: function () {
    return {
      loading: false,
      error: [],
      price: 0,
    };
  },

  methods: {
    hideAddRefundModal: function () {
      this.price = 0;
      this.error = [];
      this.$bvModal.hide("addrefund-modal");
    },
    sendRequest: function () {
      if (this.loading) {
        return;
      }
      this.loading = true;
      // this.$refs["btnSave"].classList.add(
      //   "spinner",
      //   "spinner-light",
      //   "spinner-right"
      // );
      httpHelper.setAuth();
      let refund = {
        price: this.price,
      };

      httpHelper
        .postData("refund", refund)
        .then((response) => {
          this.loading = false;
          if (response.success === true) {
            window.location.href = response.result;
            //  this.$emit("input", Math.floor(Math.random() * (100 - 1 + 1)) + 1);
            // this.$bvModal.hide("addrefund-modal");
          } else {
            this.error = [];
            for (var key in response.error) {
              response.error[key].forEach((element) => {
                this.error.push(element);
              });
            }
          }
        })
        .catch((res) => {
        });
    },
  },
};
</script>
